import dayjs from 'dayjs';

import {
    INS_DOCUMENT_EXPIRY_DATE_LIMIT,
    QUOTE_STATUSES,
} from '@ratehub/documents/ins-common/stable';


/**
 * extract "quotes" inside of a document, assign one quote to one row
 * @param {object[]} example [ {"test":"1", "quotes": ["a", "b", "c"] }, {"test":"2"} ]
 * @returns {object[]} example [ {"test":"1","quote":"a"}, {"test":"1","quote":"b"}, {"test":"1","quote":"c"}, {"test":"2"}]}
 * Please note that extractRows() should return at least { key, document }
 */
function extractAutoHomeRows(documents) {
    return documents
        .filter(doc => !isAutoHomeDocumentExpired(doc))
        .flatMap(doc => {
            if (!!doc.quotes && doc.quotes.length > 0) {
                const quotes = [ ...doc.quotes ];
                return quotes
                    .filter(quote => quote.status !== QUOTE_STATUSES.FAILED)
                    .map((quote, index) => {
                        const copied = { ...doc };
                        copied.quote = quote; // assign one quote to each row
                        return { key: `${doc.id}-quote-${index}`, document: copied };
                    });
            } else {
                return { key: doc.id, document: doc };
            }
        });
}

/* REQUIREMENT: Filter out 'expired' store, this is when the updatedAt if no userUpdatedAt is before 30 days ago
    and it has no quotes stored (it's resume-able) */
function isAutoHomeDocumentExpired(document) {
    // if customer inquired 'quotes', there's no expiry - dashboard shows QuoteDetails in this case
    if (document.quotes.length > 0) {
        return false;
    }
    // createdAt/updatedAt field was introduced few years ago, if doc doesn't have this field, it must be expired
    if (document.createdAt == null || document.updatedAt == null) {
        return true;
    }

    return dayjs(document.userUpdatedAt ?? document.updatedAt)
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .isBefore(
            dayjs()
                .subtract(INS_DOCUMENT_EXPIRY_DATE_LIMIT, 'days')
                .set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
        );
}

export default extractAutoHomeRows;
